import {provideHttpClient, withFetch, withInterceptorsFromDi, withJsonpSupport} from '@angular/common/http';
import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {BrowserModule, provideClientHydration} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {Router} from '@angular/router';
import * as Sentry from '@sentry/angular';
import {APP_ID} from './app-common/const';
import {CoreModule} from './app-common/core.module';
import {SharedModule} from './app-common/shared.module';
import {AppRoutingModule} from './app-routing.module';
import {AppInterceptorsModule} from './app.interceptors.module';
import {AppComponent} from './components/app/app.component';
import {FooterComponent} from './components/footer/footer.component';
import {HeaderComponent} from './components/header/header.component';
import {SidebarNavComponent} from './components/sidebar-nav/sidebar-nav.component';
import {AuthModule} from './modules/auth/auth.module';
import {LayoutModule} from './modules/layout/layout.module';
import {CustomDateAdapter} from './services/custom-date-adapter.service';
import {CodeSnippetsService} from './services/code-snippets.service';
import {UiIconComponent} from './components/ui/ui-icon/ui-icon.component';

const materialModules = [MatDialogModule, MatSidenavModule, MatToolbarModule];

@NgModule({
  declarations: [AppComponent, HeaderComponent, FooterComponent, SidebarNavComponent],
  bootstrap: [AppComponent],
  exports: [],
  imports: [
    LayoutModule,
    AppRoutingModule,
    CoreModule,
    AuthModule,
    SharedModule,
    BrowserModule.withServerTransition({appId: APP_ID}),
    BrowserAnimationsModule,
    ...materialModules,
    AppInterceptorsModule,
    UiIconComponent,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useFactory: () =>
        Sentry.createErrorHandler({
          showDialog: false,
        }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideClientHydration(),
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'YYYY-MM-DD',
        },
        display: {
          dateInput: 'YYYY-MM-DD',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    },
    CodeSnippetsService,
    provideHttpClient(withFetch(), withInterceptorsFromDi(), withJsonpSupport()),
  ],
})
export class AppModule {}
